
export default {
  name: 'AppGradationIcon',
  props: {
    iconName: { type: String, required: true },
    iconClass: { type: [String, Array, Object], default: null },
    iconSize: { type: Number, default: null }
  },
  computed: {
    iconComponent() {
      return this.parseComponentName(this.iconName);
    },
    iconProps() {
      const props = {};
      if (this.iconSize) {
        props.iconSize = this.iconSize;
      }
      return props;
    }
  },
  methods: {
    parseComponentName(iconName) {
      // icon-ai-gradation -> AppIconAiGradation
      const iconNameMatch = iconName.match(/^icon-(\w+)-(.+)$/);
      if (iconNameMatch) {
        const [, prefix, iconType] = iconNameMatch;
        const componentName = `AppIcon${prefix.charAt(0).toUpperCase() +
          prefix.slice(1)}${iconType.charAt(0).toUpperCase() +
          iconType.slice(1)}`;
        return componentName;
      }

      // eslint-disable-next-line no-console
      console.error(`Invalid icon name format: ${iconName}`);
      return null;
    }
  }
};
